import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Slices } from '../slices';
import { searchApi } from '../../services';

import { SearchSchema } from './types';

const initialState: SearchSchema = {
    query: '',
    exclude: [],
};

const searchSlice = createSlice({
    name: Slices.Search,
    initialState,
    reducers: {
        setSearchQuery: (state, action: PayloadAction<SearchSchema['query']>) => {
            state.query = action.payload;
            state.exclude = [];
        },
        syncSearchQuery: (state, action: PayloadAction<SearchSchema['query']>) => {
            state.query = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addMatcher(searchApi.endpoints.search.matchFulfilled, (state, action) => {
            const newIds = action.payload.map(item => Number(item.id)).filter(Boolean);

            state.exclude = state.exclude.concat(newIds);
        });
    },
});

export const { actions: searchActions, reducer: searchReducer } = searchSlice;
